import s from "./isMenuTreeHierarchyProductAvailable.mjs";
function u({
  menuOrderFormat: e,
  showProductsFromOtherOrderFormats: t = !1
}) {
  const r = {
    iteratee: ["sortOrder"],
    orders: ["asc"]
  };
  if (t) {
    const i = (o) => s(o, e);
    r.iteratee.unshift(i), r.orders.unshift("desc");
  }
  return r;
}
export {
  u as default
};
